/**
 * Logger central WebSocket (consola + localStorage, últimas 200 entradas).
 * No altera flujo de negocio; reversible borrando clave `ws_logs`.
 */

export const wsLog = (tag, data = null) => {
  try {
    const logEntry = {
      timestamp: new Date().toISOString(),
      tag,
      data,
    };

    console.log(`[${tag}]`, data);

    if (typeof localStorage === 'undefined') return;

    const existing = JSON.parse(localStorage.getItem('ws_logs') || '[]');
    existing.push(logEntry);

    if (existing.length > 200) {
      existing.shift();
    }

    localStorage.setItem('ws_logs', JSON.stringify(existing));
  } catch (e) {
    console.error('[WS_LOGGER_ERROR]', e);
  }
};
